import { useEffect, useState } from "react";
import { GET_ORDER_HISTORY, CUSTOMERID, BASEURL } from "../../CONSTANTS";
import { Container, Row, Col, Table, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import Cookies from "js-cookie";
import { useCustomScreen } from "../../Components/Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faUser,
  faCircleInfo,
  faFileImage,
  faCircleArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { use } from "react";
export default function BillingDetails() {
  const { authToken, decodedToken } = useAuth();
  const [reportDetails, setReportDetails] = useState([]); 
  const token = localStorage.getItem("token");
  const [endpoint, setEndpoint] = useState("search");
  const tokenFromCookies = Cookies.get("token");
  const customerIdFromCookies = JSON.parse(
    Cookies.get("decodedToken")
  ).customerid;
  const customerId =
    window.localStorage.getItem("customerId") || customerIdFromCookies;
  const TOKEN = window.localStorage.getItem("token") || tokenFromCookies;
  const { isLandscape1024, isPortrait1024, isIpadProPortrait } =
    useCustomScreen();
  const navigate = useNavigate();
  const [searchKey, setSeachKey] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 767);
  const [isMediumScreen, setIsMediumScreen] = useState(
    window.innerWidth >= 768 && window.innerWidth <= 1023
  );
  const [isLargeScreen, setIsLargeScreen] = useState(
    window.innerWidth >= 1024 && window.innerWidth <= 1200
  );
  const [isXlScreen, setIsXlScreen] = useState(
    window.innerWidth > 1200 && window.innerWidth <= 1400
  );
  const [isXxlScreen, setIsXxlScreen] = useState(
    window.innerWidth > 1400 && window.innerWidth <= 2000
  );
  const [is4kScreen, setIs4kScreen] = useState(window.innerWidth > 2000);
  const [showModal, setShowModal] = useState(false); 

useEffect(() => {
    if (authToken) {
      const hasModalShown = sessionStorage.getItem("modalShown");
      if (!hasModalShown) {
        setShowModal(true);
        sessionStorage.setItem("modalShown", "true");
      }
    }
  }, [authToken]);


  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 767);
      setIsMediumScreen(window.innerWidth >= 768 && window.innerWidth <= 1024);
      setIsLargeScreen(window.innerWidth > 1024 && window.innerWidth <= 1200);
      setIsXlScreen(window.innerWidth > 1200 && window.innerWidth <= 1400);
      setIsXxlScreen(window.innerWidth > 1400 && window.innerWidth <= 2000);
      setIs4kScreen(window.innerWidth > 2000);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getBillingHistory();
  }, []);

  useEffect(() => {}, [reportDetails]);
  useEffect(() => {}, [searchKey]);

  const [showClearButton, setShowClearButton] = useState(false);

  const getBillingHistory = async () => {
    const data = {
      searchKeyword: `${searchKey}`,
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortColumn: "",
      sortOrder: "",
    };
    try {
      setLoading(!loading);
      const res = await fetch(`${BASEURL}orders/searchorders/${customerId}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`, // Add your token here
        },
      });
      if (res.ok) {
        const result = await res.json();
        Array.isArray(result) && result.length > 0
          ? setReportDetails([...result])
          : setReportDetails([]);
      } else {
        if (res?.status === 401) {
          navigate("/login");
        }
      }
    } catch (e) {
      console.log("error", e);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    const data = {
      searchKeyword: `${searchKey}`,
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortColumn: "",
      sortOrder: "",
    };
    try {
      setLoading(!loading);
      const res = await fetch(`${BASEURL}orders/searchorders/${customerId}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      });
      if (res.ok) {
        const result = await res.json();
        Array.isArray(result) && result.length > 0
          ? setReportDetails([...result])
          : setReportDetails([]);
        setShowClearButton(true);
      } else {
        if (res?.status === 401) {
          navigate("/login");
        }
      }
    } catch (e) {
      console.log("error", e);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchRefresh = async () => {
    setSeachKey("");
    const data = {
      searchKeyword: "",
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortColumn: "",
      sortOrder: "",
    };
    try {
      setLoading(!loading);
      const res = await fetch(`${BASEURL}orders/searchorders/${customerId}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      });
      if (res.ok) {
        const result = await res.json();
        Array.isArray(result) && result.length > 0
          ? setReportDetails([...result])
          : setReportDetails([]);
        setShowClearButton(!showClearButton);
      } else {
        if (res?.status === 401) {
          navigate("/login");
        }
      }
    } catch (e) {
      console.log("error", e);
    } finally {
      setLoading(false);
    }
  };

  const searchKeyHandler = async (e) => {
    let value = e.target.value;
    if (value) {
      setSeachKey(value);
    } else if (value === "") {
      setSeachKey("");
      const data = {
        searchKeyword: "",
        pageIndex: pageIndex,
        pageSize: pageSize,
        sortColumn: "",
        sortOrder: "",
      };
      try {
        setLoading(!loading);
        const res = await fetch(`${BASEURL}orders/searchorders/${customerId}`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`,
          },
        });
        if (res.ok) {
          const result = await res.json();
          Array.isArray(result) && result.length > 0
            ? setReportDetails([...result])
            : setReportDetails([]);
        } else {
          if (res?.status === 401) {
            navigate("/login");
          }
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setLoading(false);
      }
    }
  };

  // const handleDownload = async (orderId) => {
  //   try {
  //     const response = await fetch(`${BASEURL}orders/${orderId}/attachments`, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${TOKEN}`,
  //       },
  //     });
  //     if (!response.ok) {
  //       console.log("Error fetching ", response.statusText);
  //     }
  //     const attachments = await response.json(); // Array of { fileName, base64 }
  //     attachments.forEach(({ fileName, base64Content }) => {
  //       if (!base64Content) return;
  //       const link = document.createElement("a");
  //       link.href = `data:image/jpeg;base64,${base64Content}`;
  //       link.download = fileName || `image.jpg`;
  //       link.style.display = "none";
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

const handleDownload = async (orderId) => {
  try {
    const response = await fetch(`${BASEURL}orders/${orderId}/attachments`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });

    if (!response.ok) {
      console.log("Error fetching ", response.statusText);
      return;
    }

    const attachments = await response.json(); 

    for (const { fileName, base64Content } of attachments) {
      if (!base64Content) continue;

      const link = document.createElement("a");
      link.href = `data:image/jpeg;base64,${base64Content}`;
      link.download = fileName || `image.jpg`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      await new Promise((res) => setTimeout(res, 250));
    }
  } catch (err) {
    console.log(err);
  }
};


  const [displayActionBtn, setDisplayActionBtn] = useState(false);
  const status = reportDetails.find((item) => item.status === "Delivered");
  useEffect(() => {
    if (reportDetails.length > 0) {
      const status = reportDetails.find((item) => item.status === "Delivered");
      if (status) {
        setDisplayActionBtn(true);
      } else {
        setDisplayActionBtn(false);
      }
    }
  }, [status]);

  return (
    <>

      <Container fluid className="pb-5 p-3" style={{ height: "auto" }}>
        <div
          style={{
            backgroundColor: "lightblue",
            padding: "1em 1em",
            width: "100%",
          }}
        >
          <h5
            style={{
              fontSize: is4kScreen
                ? "2rem"
                : isXxlScreen
                ? "1.4rem"
                : isXlScreen
                ? "1.2rem"
                : isIpadProPortrait
                ? "1.95rem"
                : isLargeScreen
                ? ""
                : isMediumScreen
                ? "1.7rem"
                : "",
              display: "flex",
              alignItems: "center",
            }}
          >
            <b>Report History</b>
          </h5>
        </div>
        <Container style={{ marginTop: "10px", marginBottom: "10px" }}>
          <Row className=" d-flex align-items-center">
            <Col
              className="profile-cont credits-purchase"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                className="form-control"
                value={searchKey}
                onChange={(e) => searchKeyHandler(e)}
              />
              {showClearButton ? (
                <button
                  style={{
                    backgroundColor: "lightblue",
                    borderRadius: "10px",
                    border: 0,
                    height: "auto",
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? "1.2rem"
                      : isXlScreen
                      ? "1.1rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? ""
                      : "",
                  }}
                  className="topbar-btns ms-3"
                  onClick={() => handleSearchRefresh()}
                >
                  clear
                </button>
              ) : (
                <button
                  style={{
                    backgroundColor: "lightblue",
                    borderRadius: "10px",
                    border: 0,
                    height: "auto",
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? "1.2rem"
                      : isXlScreen
                      ? "1.1rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? "1.2rem"
                      : "",
                  }}
                  className="topbar-btns ms-3"
                  onClick={() => handleSearch()}
                >
                  Search
                </button>
              )}
            </Col>
          </Row>
        </Container>
        <div style={{ overflowY: "auto", overflowX: "auto" }}>
          <Table
            striped
            bordered
            size="sm"
            className="p-4"
            style={{ minWidth: "100%", overflowY: "auto", overflowX: "auto" }}
          >
            <thead style={{ backgroundColor: "lightgray" }}>
              <tr style={{ backgroundColor: "lightgray" }}>
                <th
                  className="text-center"
                  style={{
                    backgroundColor: "lightgray",
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? "1rem"
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.9rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? "1.4rem"
                      : "",
                    padding: is4kScreen
                      ? "1rem"
                      : isXxlScreen
                      ? "0.5rem"
                      : isXlScreen
                      ? "0.5rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? ""
                      : isSmallScreen
                      ? ""
                      : "",
                  }}
                >
                  Address
                </th>
                <th
                  className="text-center"
                  style={{
                    backgroundColor: "lightgray",
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? "1rem"
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.9rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? "1.4rem"
                      : "",
                    padding: is4kScreen
                      ? "1rem"
                      : isXxlScreen
                      ? "0.5rem"
                      : isXlScreen
                      ? "0.5rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? ""
                      : isSmallScreen
                      ? ""
                      : "",
                  }}
                >
                  Report Type
                </th>
                <th
                  className="text-center"
                  style={{
                    backgroundColor: "lightgray",
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? "1rem"
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.9rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? "1.4rem"
                      : "",
                    padding: is4kScreen
                      ? "1rem"
                      : isXxlScreen
                      ? "0.5rem"
                      : isXlScreen
                      ? "0.5rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? ""
                      : isSmallScreen
                      ? ""
                      : "",
                  }}
                >
                  Date Ordered
                </th>
                <th
                  className="text-center"
                  style={{
                    backgroundColor: "lightgray",
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? "1rem"
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.9rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? "1.4rem"
                      : "",
                    padding: is4kScreen
                      ? "1rem"
                      : isXxlScreen
                      ? "0.5rem"
                      : isXlScreen
                      ? ""
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? ""
                      : isSmallScreen
                      ? ""
                      : "",
                  }}
                >
                  Status
                </th>
                {displayActionBtn ? (
                  <th
                    className="text-center"
                    style={{
                      backgroundColor: "lightgray",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1rem"
                        : isXlScreen
                        ? ""
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? ""
                        : "",
                      padding: is4kScreen
                        ? "1rem"
                        : isXxlScreen
                        ? "0.5rem"
                        : isXlScreen
                        ? ""
                        : isIpadProPortrait
                        ? "1.9rem"
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? "1.4rem"
                        : isSmallScreen
                        ? ""
                        : "",
                    }}
                  >
                    Action
                  </th>
                ) : (
                  ""
                )}
              </tr>
            </thead>
            <tbody
              style={{
                backgroundColor: "white",
                "--bs-table-accent-bg": "white",
                "--bs-table-striped-bg": "white",
                borderColor: "lightgray",
              }}
            >
              {loading ? (
                <tr style={{ width: "100%", minWidth: "100%" }}>
                  <td
                    colSpan="6"
                    className="text-center"
                    style={{
                      height: "100px",
                      width: "100%",
                      minWidth: "100%",
                      verticalAlign: "middle",
                    }}
                  >
                    <Spinner animation="border" role="status" />
                  </td>
                </tr>
              ) : Array.isArray(reportDetails) && reportDetails.length > 0 ? (
                reportDetails.map((report, reportInx) => (
                  <tr key={reportInx} className="border-1">
                    <td
                      className="text-center border-1"
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1rem"
                          : isXlScreen
                          ? ""
                          : isIpadProPortrait
                          ? "1.7rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? "1.3rem"
                          : "",
                        padding: is4kScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "0.5rem"
                          : isXlScreen
                          ? "0.5rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : isSmallScreen
                          ? ""
                          : "",
                      }}
                    >
                      {report?.streetAddress +
                        ", " +
                        report?.city +
                        ", " +
                        report?.state +
                        ", " +
                        report?.zip ?? "-"}
                    </td>
                    <td
                      className="text-center border-1"
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1rem"
                          : isXlScreen
                          ? ""
                          : isIpadProPortrait
                          ? "1.7rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? "1.3rem"
                          : "",
                        padding: is4kScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "0.5rem"
                          : isXlScreen
                          ? "0.5rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : isSmallScreen
                          ? ""
                          : "",
                      }}
                    >
                      {report?.type ?? "-"}
                    </td>
                    <td
                      className="text-center border-1"
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1rem"
                          : isXlScreen
                          ? ""
                          : isIpadProPortrait
                          ? "1.7rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? "1.3rem"
                          : "",
                        padding: is4kScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "0.5rem"
                          : isXlScreen
                          ? "0.5rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : isSmallScreen
                          ? ""
                          : "",
                      }}
                    >
                      {report?.createdOn
                        ? new Date(report.createdOn).toLocaleDateString("en-US")
                        : "-"}
                    </td>
                    <td
                      className="text-center border-1"
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1rem"
                          : isXlScreen
                          ? ""
                          : isIpadProPortrait
                          ? "1.7rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? "1.3rem"
                          : "",
                        padding: is4kScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "0.5rem"
                          : isXlScreen
                          ? "0.5rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : isSmallScreen
                          ? ""
                          : "",
                      }}
                    >
                      {report?.status.replace(/([a-z])([A-Z])/g, "$1 $2") ?? "-"}
                    </td>
                    {report.status === "Delivered" ? (
                      <td
                        onClick={() => handleDownload(report?.orderId)}
                        className="text-center border-1"
                        style={{
                          borderTop: "0px",
                          borderBottom: "0px",
                          color: "blue",
                          textDecoration: "underline",
                          fontSize: is4kScreen
                            ? "1.9rem"
                            : isXxlScreen
                            ? "1rem"
                            : isXlScreen
                            ? ""
                            : isIpadProPortrait
                            ? "1.7rem"
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? "1.3rem"
                            : "",
                          padding: is4kScreen
                            ? "1rem"
                            : isXxlScreen
                            ? "0.5rem"
                            : isXlScreen
                            ? "0.5rem"
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? ""
                            : isSmallScreen
                            ? ""
                            : "",
                          cursor: "pointer",
                        }}
                      >
                        Download
                      </td>
                    ) : displayActionBtn ? (
                      <th className="text-center border-1"></th>
                    ) : (
                      ""
                    )}
                  </tr>
                ))
              ) : (
                <tr className="bg-danger">
                  <td
                    colSpan="6"
                    className="text-center border-1 bg-tranperant"
                  >
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

         {showModal && (
 <Modal
    show={true}
   centered
    onHide={() => setShowModal(false)} 
  >

    <Modal.Header
      style={{
        backgroundColor: "lightblue",
        color: "black",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        padding: "12px 20px",
      }}
    >
      <Modal.Title>
        <strong style={{ fontSize: "1.2rem", color: "black" }}>Note</strong>
      </Modal.Title>
    </Modal.Header>


    <Modal.Body
      style={{
        color: "black",
        padding: "14px",
        maxWidth: "70vw", 
        margin: "0 auto", 
      }}
    >
      We have recently updated our site. If you are logging in for the first time after 8/2/25 then you will need to re-enter your credit card information to order new reports. Just click on{" "}
      <strong style={{cursor:"pointer"}} onClick={()=> navigate("/profile/order-history")}> Billing information</strong> to add your card.
    </Modal.Body>


    <Modal.Footer
      style={{
        justifyContent: "flex-end",
        padding: "10px 20px 20px 20px",
        
      }}
    >
      <button
        onClick={() => setShowModal(false)}
        style={{
          backgroundColor: "lightblue",
          color: "black",
          border: "none",
          borderRadius: "6px",
          padding: "8px 16px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Close
      </button>
    </Modal.Footer>
  </Modal> 
)}
      </Container>

    </>
  );
}